
import { Vue } from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';

export default class Checkbox extends Vue {
	@PropSync('value', { type: Boolean }) valueCheckbox!: boolean;
	@PropSync('color', { type: String }) color!: string;
	@PropSync('disabled', { type: Boolean }) disabled = false;
	@PropSync('disabledAction', { type: Boolean }) disabledAction = false;

	toggle() {
		if (this.disabled || this.disabledAction) return;
		this.valueCheckbox = !this.valueCheckbox;
	}
}
